export default {
    /**
     * Toutes les écritures renvoient la liste complète des rôles : on remplace
     * l'état plutôt que de le rapiécer, aucun rechargement n'est nécessaire.
     */
    setRoles(state, roles) {
        state.roles = Array.isArray(roles) ? roles : []
    },
    setPermissionGroups(state, groups) {
        state.permissionGroups = Array.isArray(groups) ? groups : []
    },
    setLoading(state, value) {
        state.loading = value
    }
}
